import { useGlobalStore } from 'store';
import bindActions from 'store/bindActions';
import reducer from 'store/flow';

const { actions } = reducer;

const useFlow = () => {
	const { state, dispatch } = useGlobalStore();

	// List of Props
	const { items, error, isLoading } = state.flow;

	// List of Actions
	const { handleGet, handleAdd, handleTrigger } = actions;

	// Bind Actions
	const boundActions = bindActions(
		{
			handleGet,
			handleAdd,
			handleTrigger,
		},
		dispatch
	);

	return { items, error, isLoading, ...boundActions };
};

export default useFlow;
